var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbotUserMsgIocn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3097_190278)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3097_190278",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3097_190278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54402 10.006C6.12925 10.006 6.60368 9.5316 6.60368 8.94637C6.60368 8.36114 6.12925 7.88672 5.54402 7.88672C4.95879 7.88672 4.48438 8.36114 4.48438 8.94637C4.48438 9.5316 4.95879 10.006 5.54402 10.006Z",
    fill: "#619BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4658 10.006C13.051 10.006 13.5255 9.5316 13.5255 8.94637C13.5255 8.36114 13.051 7.88672 12.4658 7.88672C11.8806 7.88672 11.4062 8.36114 11.4062 8.94637C11.4062 9.5316 11.8806 10.006 12.4658 10.006Z",
    fill: "#619BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00588 0.0107457C7.42364 0.0096392 5.86908 0.425693 4.49891 1.21696C3.12875 2.00823 1.99141 3.14675 1.20156 4.51774C0.411712 5.88873 -0.00273278 7.44372 1.35607e-05 9.02595C0.0027599 10.6082 0.4226 12.1617 1.2172 13.53C1.21633 13.5388 1.21633 13.5476 1.2172 13.5564V16.1535C1.2172 16.3398 1.29122 16.5185 1.42298 16.6503C1.55474 16.782 1.73344 16.856 1.91978 16.856H4.59701C5.79703 17.5282 7.13512 17.9164 8.50855 17.9909C9.88197 18.0654 11.2542 17.8242 12.5199 17.2858C13.7856 16.7474 14.9111 15.9261 15.8099 14.885C16.7088 13.8439 17.3571 12.6107 17.7052 11.28C18.0533 9.94933 18.0918 8.55659 17.8177 7.20872C17.5437 5.86084 16.9645 4.59368 16.1245 3.50452C15.2846 2.41535 14.2062 1.53315 12.9721 0.925649C11.7381 0.318144 10.3813 0.00149092 9.00588 0V0.0107457ZM9.00588 16.0072C7.62242 16.0063 6.27026 15.5954 5.12029 14.8263C3.97032 14.0572 3.07416 12.9645 2.54507 11.6862C2.01599 10.4079 1.87772 9.00145 2.14776 7.64461C2.4178 6.28776 3.08402 5.04143 4.06221 4.06312C5.04041 3.08481 6.28667 2.41845 7.64348 2.14825C9.00029 1.87805 10.4068 2.01614 11.6851 2.54508C12.9635 3.07401 14.0563 3.97004 14.8255 5.11992C15.5948 6.2698 16.0059 7.62192 16.0068 9.00537C16.0072 9.92488 15.8263 10.8354 15.4746 11.685C15.1229 12.5346 14.6072 13.3066 13.9571 13.9568C13.3069 14.6071 12.535 15.1228 11.6855 15.4746C10.8359 15.8264 9.92539 16.0074 9.00588 16.0072Z",
    fill: "#619BF3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3097_190278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotUserMsgIocn);
export default __webpack_public_path__ + "static/media/Chatbot_user_msg_iocn.2ed0f455be9c0ce88e6fbecd74851f4f.svg";
export { ForwardRef as ReactComponent };